(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["btf-cart-extras"] && !Shopify.designMode) return;
  try {
    (() => {
    const SLOT = '[data-btf-cart-slot]';

    const dims = (text) => {
      const nums = String(text)
        .toLowerCase()
        .replace(/×/g, 'x')
        .replace(/[()]/g, ' ')
        .split(/x/)
        .map((part) => parseFloat(String(part).replace(/[^0-9.]/g, '')))
        .filter((n) => !Number.isNaN(n) && n > 0);
      return nums.length >= 2 ? [nums[0], nums[1]] : null;
    };

    const band = (big) => (big > 80 ? 'Large' : big > 60 ? 'Medium' : big > 0 ? 'Small' : '');

    // "Landscape / Large 75cm x 100cm" reads "Large, 100 × 75 cm · landscape", as drawn.
    const optionText = (raw, portrait) => {
      const value = raw.trim().replace(/,\s*$/, '');
      if (!value) return '';
      const lower = value.toLowerCase();
      if (lower === 'landscape' || lower === 'portrait') return lower;
      // Some products carry the size as a bare word rather than dimensions. "Large" alone
      // reads as a stray adjective in the line, so it is named.
      if (lower === 'small' || lower === 'medium' || lower === 'large') return 'Size ' + lower;
      const pair = dims(value);
      if (!pair) return value;
      const big = Math.max(pair[0], pair[1]);
      const small = Math.min(pair[0], pair[1]);
      const name = band(big);
      const size = portrait ? small + ' × ' + big : big + ' × ' + small;
      return (name ? name + ', ' : '') + size + ' cm';
    };

    const propertyText = (label, value) => {
      const name = label.replace(/:\s*$/, '').trim().toLowerCase();
      const text = value.trim();
      if (!text) return '';
      // An uploaded file (the artwork, its print PDF): the line's picture already shows the
      // design, and Shopify names uploads with a long code, so it stays out of the wording
      if (/^(https?:)?\/\//i.test(text) || text.includes('/uploads/') || text.includes('/cdn/')) return '';
      // A statement rather than the customer's own words, so it is not put in quotes.
      if (name === 'proof') return text.charAt(0).toLowerCase() + text.slice(1);
      // The approval tick ("Yes, 19 Oct 2026 at 10:16") reads as "approved 19 Oct 2026 at 10:16"
      if (name === 'approved for print') return 'approved ' + text.replace(/^yes,?\s*/i, '');
      return name + ' “' + text + '”';
    };

    // One line of wording per cart line: size, orientation, then the customer's own words.
    const rewriteMeta = (row) => {
      const wrapper = row.querySelector('.cart-items__variants-wrapper');
      if (!wrapper || wrapper.querySelector('.btf-cart-line__meta')) return;

      const options = [...row.querySelectorAll('.cart-items__variant dd')].map((dd) => dd.textContent || '');
      const portrait = options.some((value) => value.trim().toLowerCase().startsWith('portrait'));
      const sizes = [];
      const others = [];

      for (const value of options) {
        const text = optionText(value, portrait);
        if (!text) continue;
        // The design names the board first — "Large, 100 × 75 cm · landscape".
        if (dims(value) || /^size\b/i.test(text)) sizes.push(text);
        else others.push(text);
      }

      const parts = sizes.concat(others);

      for (const property of row.querySelectorAll('.cart-items__property')) {
        const label = property.querySelector('dt');
        const value = property.querySelector('dd');
        if (!label || !value) continue;
        // Horizon shows an uploaded file as a link carrying only its file name
        const link = value.querySelector('a[href]');
        if (link && /\/uploads\/|cdn\.shopify\.com|\/cdn\//.test(link.getAttribute('href'))) continue;
        const text = propertyText(label.textContent || '', value.textContent || '');
        if (text) parts.push(text);
      }

      if (!parts.length) return;

      const line = document.createElement('span');
      line.className = 'btf-cart-line__meta';
      line.textContent = parts.join(' · ');

      for (const list of row.querySelectorAll('.cart-items__variants, .cart-items__properties')) {
        list.hidden = true;
        list.style.display = 'none';
      }
      wrapper.insertBefore(line, wrapper.firstChild);
    };

    const place = () => {
      const page = document.querySelector('.cart-page');
      if (!page) return;

      const labels = document.querySelector('.btf-cart-labels');
      const totalLabel = labels ? (labels.dataset.totalLabel || '').trim() : '';
      const editLabel = labels ? (labels.dataset.editLabel || '').trim() : '';
      const removeLabel = labels ? (labels.dataset.removeLabel || '').trim() : '';

      const mobileLines = labels ? (labels.dataset.mobileLines || 'plain').trim() : 'plain';
      page.classList.remove('cart-page--lines-plain', 'cart-page--lines-links', 'cart-page--lines-full');
      page.classList.add('cart-page--lines-' + mobileLines);

      const inner = page.querySelector('.cart-summary__inner');
      const top = page.querySelector('[data-btf-cart-slot="top"]');
      const foot = page.querySelector('[data-btf-cart-slot="foot"]');
      const count = page.querySelector('[data-btf-cart-slot="count"]');
      const title = page.querySelector('.cart-title');

      if (inner) {
        if (top && top.parentElement !== inner) inner.insertBefore(top, inner.firstChild);
        if (foot && foot.parentElement !== inner) inner.appendChild(foot);
      }
      if (count && title && count.parentElement !== title) title.appendChild(count);

      // Horizon calls it an estimated total; the design calls it the total.
      if (totalLabel) {
        for (const node of page.querySelectorAll('.cart-totals__total-label')) {
          if (node.textContent.trim() !== totalLabel) node.textContent = totalLabel;
        }
      }

      const checkoutLabel = labels ? (labels.dataset.checkoutLabel || '').trim() : '';
      if (checkoutLabel) {
        for (const node of page.querySelectorAll('.cart__checkout-button .button-text')) {
          if (node.textContent.trim() !== checkoutLabel) node.textContent = checkoutLabel;
        }
      }

      // The shop's money format carries a space after the sign; the design does not.
      for (const node of page.querySelectorAll('.btf-cart-price bdi, .cart-totals__total-value bdi')) {
        const tidy = node.textContent.replace(/(\p{Sc})\s+/gu, '$1');
        if (tidy !== node.textContent) node.textContent = tidy;
      }

      // key -> the page the line was configured on, from the JSON the block printed above
      let editMap = null;
      const editEntry = (row) => {
        if (editMap === null) {
          const tag = document.querySelector('[data-btf-edit-map]');
          try {
            editMap = tag ? JSON.parse(tag.textContent || '{}') : {};
          } catch (e) {
            editMap = {};
          }
        }
        const id = row.id || '';
        const lineKey = id.startsWith('CartItem-') ? id.slice('CartItem-'.length) : '';
        return (lineKey && editMap[lineKey]) || null;
      };

      const reopenUrl = (row) => {
        const entry = editEntry(row);
        if (!entry || !entry.e) return '';
        const id = row.id.slice('CartItem-'.length);
        return entry.e + '?edit=' + encodeURIComponent(id);
      };

      // The line's picture is the board the customer made, not the catalogue shot of a blank
      // one. Create Your Own stores that crop as the "Your artwork" property when it adds to
      // the basket; lines without one keep the product image.
      const showArtwork = (row) => {
        const entry = editEntry(row);
        const src = entry && entry.i;
        if (!src || !/^(https?:)?\/\/|^data:image\//.test(src)) return;
        const img = row.querySelector('.cart-items__media-image');
        if (!img || img.dataset.btfArtwork === '1') return;
        // A fresh image rather than a new src on the lazy one: Safari left the swapped lazy
        // image unpainted (a black block on the dark frame). Uploads on Shopify's CDN take
        // ?width, so the thumbnail comes small. If it will not load, the product photo stays.
        const art = img.cloneNode(false);
        art.removeAttribute('srcset');
        art.removeAttribute('sizes');
        art.removeAttribute('loading');
        art.dataset.btfArtwork = '1';
        // Sized to the box outright, and the whole board shown: Safari drew the large upload at
        // its own size inside the box, so only the empty middle of the board showed (a plain
        // colour block, Duncan 17 Oct 2026)
        art.removeAttribute('width');
        art.removeAttribute('height');
        art.style.width = '100%';
        art.style.height = '100%';
        art.style.aspectRatio = 'auto';
        art.style.objectFit = 'contain';
        art.style.objectPosition = '50% 50%';
        art.onload = () => img.replaceWith(art);
        art.src = /^https:\/\/cdn\.shopify\.com\/.+\/uploads\//.test(src) ? src.split('?')[0] + '?width=400' : src;
        img.dataset.btfArtwork = '1';
      };

      for (const row of page.querySelectorAll('.cart-items__table-row')) {
        rewriteMeta(row);
        showArtwork(row);

        const remove = row.querySelector('.cart-items__remove');
        if (!remove) continue;

        let actions = row.querySelector('.btf-cart-actions');
        if (!actions) {
          actions = document.createElement('div');
          actions.className = 'btf-cart-actions';
          const titleLink = row.querySelector('.cart-items__title');
          // A personalised line reopens the tool it was made in, carrying its own key, so the
          // customer amends the board rather than starting again. Everything else keeps the
          // product link it already had.
          const reopen = reopenUrl(row);
          if (reopen && titleLink) titleLink.setAttribute('href', reopen);
          if (editLabel && titleLink) {
            const edit = document.createElement('a');
            edit.className = 'btf-cart-edit';
            edit.href = reopen || titleLink.getAttribute('href') || '#';
            edit.textContent = editLabel;
            actions.appendChild(edit);
          }
          const details = row.querySelector('.cart-items__details');
          (details || remove.parentElement).appendChild(actions);
        }
        if (remove.parentElement !== actions) actions.appendChild(remove);

        // The design stacks the price under the stepper, clear of the line's wording.
        const quantity = row.querySelector('.cart-items__quantity');
        const price = row.querySelector('.cart-items__price text-component, .cart-items__price bdi');
        if (quantity && price && price.parentElement !== quantity) {
          price.classList.add('btf-cart-price');
          quantity.appendChild(price);
        }
        if (removeLabel && remove.querySelector('svg, .svg-wrapper')) remove.textContent = removeLabel;
      }
    };

    const purchaseOrder = () => {
      const root = document.querySelector('.btf-cart-po');
      if (!root || root.dataset.btfReady) return;
      root.dataset.btfReady = '1';

      const toggle = root.querySelector('.btf-cart-po__toggle');
      const panel = root.querySelector('.btf-cart-po__panel');
      const status = root.querySelector('.btf-cart-po__status');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', () => {
        const open = panel.hidden;
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (open) {
          const first = panel.querySelector('input');
          if (first) first.focus();
        }
      });

      panel.addEventListener('submit', async (event) => {
        event.preventDefault();
        const data = new FormData(panel);
        const company = String(data.get('company') || '').trim();
        const reference = String(data.get('po_reference') || '').trim();
        if (!company || !reference) return;

        const endpoint = (root.dataset.endpoint || '').trim();
        const body = (root.dataset.body || '')
          .replace('[company]', company)
          .replace('[reference]', reference);

        if (!endpoint) {
          // No proxy configured yet: hand the same contents to the studio by email.
          const subject = (root.dataset.subject || 'Purchase order') + ' — ' + reference;
          const href =
            'mailto:' +
            (root.dataset.email || '') +
            '?subject=' +
            encodeURIComponent(subject) +
            '&body=' +
            encodeURIComponent(body);
          window.location.href = href;
          if (status) {
            status.hidden = false;
            status.textContent = 'Your email programme has opened with the order in it. Send it and we will reply with a proforma.';
          }
          return;
        }

        if (status) {
          status.hidden = false;
          status.textContent = 'Sending…';
        }

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ company, po_reference: reference, summary: body }),
          });
          if (!response.ok) throw new Error(String(response.status));
          if (status) status.textContent = 'Thank you. We will email a proforma against ' + reference + '.';
          panel.reset();
        } catch (error) {
          if (status) status.textContent = 'That did not send. Please email ' + (root.dataset.email || '') + ' with your PO reference.';
        }
      });
    };

    const init = () => {
      const component = document.querySelector('cart-items-component');
      if (!component) return;

      const apply = () => {
        place();
        purchaseOrder();
      };

      const observer = new MutationObserver(() => {
        observer.disconnect();
        apply();
        observer.observe(component, { childList: true, subtree: true });
      });

      apply();
      observer.observe(component, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    // A personalised line added through Horizon's own form (the street signs) can reach the
    // basket before its print file was tidied into a JPEG link at the top: do it here, once
    if (!window.btfBasketTidied && window.btfAssets && window.btfAssets.printJpeg) {
      window.btfBasketTidied = true;
      import(window.btfAssets.printJpeg)
        // A tidied line gets a new key, so the basket page is drawn again to match
        .then((PJ) => PJ.tidyBasket())
        .then((n) => n && /^\/cart\/?$/.test(window.location.pathname) && window.location.reload())
        .catch(() => {});
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
